import { FormattedMessage } from 'react-intl';
import React from 'react';
import { DELIVERED_VIEW_ID, SHIPPED_VIEW_ID } from './view-id-constants';

export const Delivered = {
  label: <FormattedMessage defaultMessage='Delivered' description='ordersPage.nav.delivered' id='CJBHOs' />,
  id: DELIVERED_VIEW_ID,
  expandedDescription: <FormattedMessage defaultMessage='Shipped / Delivered' description='ordersPage.nav.deliveredExpanded' id='5CR8gZ' />,
  parentId: SHIPPED_VIEW_ID,
};
